module.exports = __webpack_public_path__ + "static/media/Ezugi2.452cb319.webp";